jQuery(($) => {

    function openInput($element) {
        $element.closest(".m-field").addClass("m-field--focused");
        var form = $element.closest('.m-search-form');

        if (!form.hasClass('m-search-form--hovered')) {
            form.addClass('m-search-form--hovered');
        }
    }

    function maybeCloseInput($element) {
        if ($element.val() !== '') {
            $element.closest(".m-field").addClass("m-field--focused").removeAttr("style");
        } else {
            $element.closest(".m-field").removeClass("m-field--focused");
            var form = $element.closest('.m-search-form');

            if (form.hasClass('m-search-form--hovered')) {
                form.removeClass('m-search-form--hovered');
            }
        }
    }

    if ($('.m-search-form .m-field input[type="text"]')[0]) {
        var $input = $(".m-search-form .m-field input[type='text']");

        $input.focus(function () {
            openInput($(this));
        });

        $input.blur(function () {
            maybeCloseInput($(this));
        });
    }

    $(".m-search-form .m-field").mouseenter(function () {
        $(this).addClass('m-field--hovered');
    }).mouseout(function () {
        $(this).removeClass('m-field--hovered');
    });
});